import { Validation } from "@singularsystems/neo-core";
import { Neo, NeoGrid } from "@singularsystems/neo-react";
import { observer } from "mobx-react";
import React from "react";
import InfoLabelHover from "../../../Common/Components/InfoLabelHover/InfoLabelHover";
import { TextConstants } from "../../../Common/TextConstants";
import ManageCheckQueryConfigComponentVM from "./ManageCheckQueryConfigComponentVM";

interface IManageCheckQueryConfigComponentProps {
    viewModel: ManageCheckQueryConfigComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageCheckQueryConfigComponent extends React.Component<IManageCheckQueryConfigComponentProps> {
    public render() {
        var viewModel = this.props.viewModel;

        var editOrAdd = viewModel.managedCheckQueryConfig.staticServiceProviderHouseCheckQueryId !== 0;
        return (
            <div>
                {<Neo.Card title={editOrAdd ? TextConstants.Titles.EditDataValidationConfiguration : TextConstants.Titles.AddDataValidationConfiguration} className="m-1">
                    <div>
                        <Neo.Form
                            model={viewModel.managedCheckQueryConfig}
                            onSubmit={() => {
                                if(viewModel.initImportProcessStepValue === 0 || viewModel.initImportProcessStepValue === viewModel.managedCheckQueryConfig.importProcessStepId)
                                this.props.onSave()}
                            }
                            validationDisplayMode={Validation.DisplayMode.AfterSubmit}
                            showSummaryModal>
               
                            <Neo.Modal title={TextConstants.Notifications.Warning} bind={viewModel.meta.showConfirmationModal}
                                closeButton={{ text: TextConstants.Buttons.Back , variant: "secondary"}}
                                acceptButton={{ text: TextConstants.Buttons.Submit , variant: "primary", onClick: () => {this.props.onSave()}}}>
                                    {TextConstants.Tooltips.ImportProcessStepIndicatorInfo}
                            </Neo.Modal>

                            <Neo.GridLayout>
                                {
                                    editOrAdd 
                                    ?
                                    <Neo.FormGroup
                                        display={viewModel.managedCheckQueryConfig.meta.checkQueryName}
                                        label={TextConstants.Labels.CheckQueryName}
                                    />
                                    :
                                    <Neo.FormGroup>
                                        <Neo.AutoCompleteDropDown
                                            itemSource={viewModel.checkQueryApiClient.getCheckQueryDropdownList}
                                            bind={viewModel.managedCheckQueryConfig.meta.checkQueryId}
                                            bindDisplay={viewModel.managedCheckQueryConfig.meta.checkQueryName}
                                            descriptionMember={"checkQueryDescription"}
                                            onItemSelected={(item) => viewModel.onCheckQueryItemSelected(item?.checkQueryDescription)}
                                            items={viewModel.checkQueryApiClient.getCheckQueryDropdownList(" ").then((arr) => arr.data.slice(0,10)
                                            .sort((x,y)=> x.checkQueryName.localeCompare(y.checkQueryName)))}
                                        />
                                    </Neo.FormGroup>
                                }
                            </Neo.GridLayout>

                            <Neo.GridLayout lg={1}>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.DataReportDescription}
                                    bind={viewModel.managedCheckQueryConfig.meta.checkQueryDescription}
                                    disabled={true}
                                    input={{ rows: 3 }} />
                            </Neo.GridLayout>

                            <Neo.GridLayout lg={2}>
                                <Neo.FormGroup 
                                    bindContext={viewModel.managedCheckQueryConfig.meta.serviceProviderGroupingName}
                                    label={TextConstants.Labels.Broker}>
                                    <Neo.AutoCompleteDropDown
                                        itemSource={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                                        bind={viewModel.managedCheckQueryConfig.meta.staticServiceProviderFileGroupingId}
                                        bindDisplay={viewModel.managedCheckQueryConfig.meta.serviceProviderGroupingName}
                                        displayMember={"serviceProviderGroupingName"} 
                                        items={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                        .sort((x,y)=> x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}    
                                    />
                                </Neo.FormGroup>

                                <NeoGrid.Grid items={viewModel.emailAddressesList}
                                    addButton={{
                                        icon: "none",
                                        text: TextConstants.Buttons.AddEmailAddress
                                    }}>
                                    {(item) => (
                                        <NeoGrid.Row>
                                            <NeoGrid.Column bind={item.meta.emailAddress}/>
                                            <NeoGrid.ButtonColumn 
                                                showDelete 
                                                deleteButton={{ variant: "secondary" }}/>
                                        </NeoGrid.Row>
                                    )}
                                </NeoGrid.Grid>
                                
                                <>
                                    <Neo.FormGroup
                                    className="importProcessStep"
                                        label={ 
                                                <InfoLabelHover
                                                
                                                    title={TextConstants.Labels.ImportProcessStep} 
                                                    content={TextConstants.Tooltips.ImportProcessStepIndicatorInfo}/>}>
                                        <Neo.AutoCompleteDropDown 
                                            itemSource={viewModel.checkQueryApiClient.getImportProcessStepDropdownList}
                                            bind={viewModel.managedCheckQueryConfig.meta.importProcessStepId}
                                            bindDisplay={viewModel.managedCheckQueryConfig.meta.proceedsProcess}
                                            items={viewModel.checkQueryApiClient.getImportProcessStepDropdownList().then((arr) => arr.data.slice(0,10))}/>
                                    </Neo.FormGroup>
                                    
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.RunFrequencyMinutes}>
                                        <Neo.NumberInput
                                            bind={viewModel.managedCheckQueryConfig.meta.runFrequency} />
                                    </Neo.FormGroup>
                                </>
                                
                                <>
                                    <Neo.FormGroup>
                                        <Neo.NumberInput
                                            label={TextConstants.Labels.MaxVariance}
                                            bind={viewModel.managedCheckQueryConfig.meta.maxVariance} />
                                    </Neo.FormGroup>

                                    <Neo.FormGroup>
                                        <Neo.NumberInput
                                            label={TextConstants.Labels.MinVariance}
                                            bind={viewModel.managedCheckQueryConfig.meta.minVariance} />
                                    </Neo.FormGroup>
                                </>
                                
                            </Neo.GridLayout>
                            <Neo.GridLayout className="row pt-3">
                                <Neo.FormGroup
                                    label={<InfoLabelHover title={TextConstants.Labels.RunForServiceProvider} content={TextConstants.Tooltips.RunsForServiceProviderInfo}/>}
                                    bind={viewModel.managedCheckQueryConfig.meta.runForStaticServiceProviderInd} />
                                <Neo.FormGroup
                                    label={TextConstants.Labels.IsActive}
                                    bind={viewModel.managedCheckQueryConfig.meta.activeInd} />
                                <Neo.FormGroup
                                    label={<InfoLabelHover title={TextConstants.Labels.ProvideResultSetInEmailBody} content={TextConstants.Tooltips.DataTableInBodyInfo}/>}
                                    bind={viewModel.managedCheckQueryConfig.meta.dataTableIsInBodyInd} />
                                <Neo.FormGroup
                                    label={<InfoLabelHover title={TextConstants.Labels.TriggerNextExecutionDate} content={TextConstants.Tooltips.TriggerNextExecutionDateTooltip}/>}
                                    bind={viewModel.managedCheckQueryConfig.meta.triggerNextExecutionDate} />
                                <Neo.FormGroup
                                    label={TextConstants.Labels.AddResultInd}
                                    bind={viewModel.managedCheckQueryConfig.meta.addResultInd} />
                            </Neo.GridLayout>
                            <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                    onClick={() => viewModel.updateManagedObjectBeforeValidation()}
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                        </Neo.Form>
                    </div>
                </Neo.Card>
                }
            </div>
        )
    }
}